import {
  connectWithFacebook,
  connectWithGoogle,
  SocialConnectPayload
} from 'common/api/SsoApi';
import { IdentityProviderTypes } from 'common/constants/IdentityProvidersTypes';
import { path } from 'common/tools/network/routing';
import { getUrlParams } from 'common/tools/network/url';

type SocialConnectResponse = { hasJustSignedUp: boolean };

const connectWithSocialProvider: Record<
  IdentityProviderTypes,
  (payload: SocialConnectPayload) => Promise<SocialConnectResponse>
> = {
  [IdentityProviderTypes.FACEBOOK]: connectWithFacebook,
  [IdentityProviderTypes.GOOGLE]: connectWithGoogle
};

export const connect = async (
  provider: IdentityProviderTypes,
  payload: SocialConnectPayload
) => {
  const response = await connectWithSocialProvider[provider](payload);

  const { returnUrl, noOnboarding } = getUrlParams(window.location.href) || {};
  // if the user has signed up via a social network
  // we force the user provenance to USER_PROVENANCE_SIGN_UP, and set the cookie
  if (response.hasJustSignedUp && !noOnboarding) {
    let redirectToOnboarding = path('userspace_onboarding');
    if (returnUrl) {
      redirectToOnboarding = `${redirectToOnboarding}?returnUrl=${returnUrl}`;
    }
    window.location.href = redirectToOnboarding;
  } else if (returnUrl) {
    window.location.href = returnUrl;
  } else {
    window.location.href = path('homepage');
  }
};
